import Component from 'Component';
import $ from '../vendor/CustomJquery';
import Dropzone from 'dropzone';
import Manager from "./storage/Manager";

export default class Storage extends Component {

  _namespace = this.constructor.name;

  _components = [
    new Manager(this.App, this._namespace)
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}